import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import GeneralDialog from "../GeneralDialog";
import {Step, StepLabel, Stepper} from "@mui/material";
import {SubWorkspaceGeneralSettings} from "../../Domain/SubWorkspaceManagment/SubWorkapaceSettings/SubWorkspaceGeneralSettings";
import {SubWorkspacePermissions} from "../../Domain/SubWorkspaceManagment/SubWorkapaceSettings/SubWorkspacePermissions";
import {EditMirrorItems} from "./EditMirrorItems";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import ConditionalComponent from "../../Shared/ConditionalComponent";

const steps = ['Settings', 'Permissions', 'Project selection'];

const CreateEditWorkspaceModal = observer(() => {
    const {workspaceManagementStore, modalStore, generalStore} = useStores();
    useEffect(() => {
        if (modalStore.isCreateEditWorkspaceModalOpen && generalStore.availableSeats === 0){
            workspaceManagementStore.validationEditsState.MaxUsers = false
        }else{
            workspaceManagementStore.validationEditsState.MaxUsers = true
        }
    }, [modalStore.isCreateEditWorkspaceModalOpen, generalStore.availableSeats]);
    const renderBody = () => {
        switch (workspaceManagementStore.currentStep) {
            case 0:
                return (<SubWorkspaceGeneralSettings/>);
            case 1:
                return (<SubWorkspacePermissions/>);
            case 2:
                return (<EditMirrorItems/>)

        }
    }
    const onConfirm = async () => {
        const updatedNewDomainSettings = await workspaceManagementStore.handleOnConfirmEditCreateWorkspace()
        modalStore.isCreateEditWorkspaceModalOpen = false
    }
    const onEnter = async () =>{
        await workspaceManagementStore.handleFetchSub()
    }
    const onNextStep = ()=>{
        const nameValid = workspaceManagementStore.isNameSavingValid()
        const ownerValid = workspaceManagementStore.isValidEmail
        const maxUsersValid = Number.isInteger(Number(workspaceManagementStore.editedDomain.MaxUsers)) && workspaceManagementStore.editedDomain.MaxUsers > 0 && workspaceManagementStore.editedDomain.MaxUsers <= generalStore.availableSeats
        if (workspaceManagementStore.currentStep === 0 && (!nameValid || !ownerValid || !maxUsersValid)){
            workspaceManagementStore.validationEditsState.WorkspaceDisplayedName = nameValid;
            workspaceManagementStore.validationEditsState.Owner = ownerValid;
            workspaceManagementStore.validationEditsState.MaxUsers = maxUsersValid;
            return ;
        }
        workspaceManagementStore.currentStep += 1
    }
    const handleGoBack = () => {
        workspaceManagementStore.currentStep -= 1
    }
    const specialOnClose = () => {
        workspaceManagementStore.resetData()
    }
    const renderGoBackButton = () => {

        return (
            <ConditionalComponent if={workspaceManagementStore.currentStep > 0}>
                <button className="absolute top-5 left-5 items-center gap-2 font-bold text-sm" onClick={handleGoBack}>
                    <KeyboardBackspaceOutlinedIcon fontSize="medium"/>
                </button>
            </ConditionalComponent>
        )
    }
    const renderTitle = () => {
        return (
            workspaceManagementStore.isWorkspaceNew ?
                <>
                    {renderGoBackButton()}
                    <Stepper className='' alternativeLabel activeStep={workspaceManagementStore.currentStep}>
                        {steps.map((label) => {
                            const stepProps = {};
                            const labelProps = {};

                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </> :
                <span className="block text-center text-[var(--windowsandmenus-normal-text-color)] font-bold text-2xl font-sans" style={{marginTop: '-40px'}}>
                    Mirrored Projects
                </span>
        )
    }
    const isConfirmDisabled = () => {
        switch (workspaceManagementStore.currentStep) {
            case 0:
                if (!workspaceManagementStore.isNameImmediateValid(workspaceManagementStore.editedDomain.WorkspaceDisplayedName) || !workspaceManagementStore.editedDomain.Country) {
                    return true;
                }
                return false;
            case 2:
                if (workspaceManagementStore.isWorkspaceNew && workspaceManagementStore.addedProjects.size <= 0) {
                    return true;
                }
                return workspaceManagementStore.changedMirroredProjectsCount

        }
    }
    const confirmText = () => {
        switch (workspaceManagementStore.currentStep) {
            case 0:
            case 1:
                return 'Next'
            case 2:
                if (workspaceManagementStore.isWorkspaceNew) {
                    return 'Create';
                } else {
                    return 'Update';
                }
        }
    }
    return (
        <>
            <GeneralDialog
                openControl='isCreateEditWorkspaceModalOpen'
                className='procedure-option-dialog sub-workspace-popup'
                data-testid="create-workspace-modal"
                disableBackdropClick={!workspaceManagementStore.isWorkspaceNew}
                title={renderTitle()}
                body={renderBody()}
                onEnter={onEnter}
                isConfirmDisabled={isConfirmDisabled()}
                confirmText={confirmText()}
                onConfirm={() => workspaceManagementStore.currentStep < 2 ? onNextStep() : onConfirm()}
                specialOnClose = {specialOnClose}

            />
        </>
    );
});

export default CreateEditWorkspaceModal;
